import type { ReactNode } from 'react'

import { cn } from '@/utils'

interface SectionHeadingProps {
  title: string
  description?: ReactNode
  actions?: ReactNode
  className?: string
}

// The heading that sits above a group of cards or a table, one step below the page title.
export const SectionHeading = ({
  title,
  description,
  actions,
  className,
}: SectionHeadingProps) => (
  <div className={cn('flex items-start justify-between gap-4', className)}>
    <div className="min-w-0 space-y-1">
      <h2 className="text-lg font-semibold tracking-tight text-blue-7">
        {title}
      </h2>
      {description ? (
        <p className="text-sm text-ink-subtle">{description}</p>
      ) : null}
    </div>
    {actions ? (
      <div className="flex shrink-0 items-center gap-2">{actions}</div>
    ) : null}
  </div>
)
